import { Div, Span } from '@driftt/tide-core'
import { pluralize } from 'humanize-plus'
import { compose } from 'ramda'
import React from 'react'
import onClickOutside from 'react-onclickoutside-decorator'
import { withRouter } from 'react-router-dom'
import scrollIntoView from 'scroll-into-view'

import { pause } from 'utils'

const showErrorMargin = (id, isEmptyPath) => {
  const errorNode = isEmptyPath
    ? document.querySelector(`#node-${id} .empty-path-bucket`)
    : document.querySelector(`#node-${id} .tide-div.skill-node`)

  if (errorNode) {
    errorNode.classList.add('error-node-margin')
  }
}

const Dropdown = ({
  location,
  history,
  match,
  editorErrors,
  onClickOutside,
}) => {
  const numOfKnownErrors = Object.keys(editorErrors).length
  const isBlock = location.pathname.includes('blocks')
  const notifierHeader = `You have ${numOfKnownErrors} ${
    isBlock ? 'block' : 'playbook'
  } ${pluralize(numOfKnownErrors, 'error')}`

  const scrollToNode = (id) => {
    const $target = document.querySelector(`#node-${id} .inline-node`)
    $target && scrollIntoView($target)
  }

  const handleScrollTo = async (source, id) => {
    const { params } = match

    if (source === 'AUDIENCE') {
      if (!location.pathname.includes('targeting')) {
        history.push(`/editor/${params.id}/targeting/builder`)
      }
    }

    if (['BUILDER', 'EXPERIMENT'].includes(source)) {
      if (!location.pathname.includes('visual-builder')) {
        history.push(
          `/editor/${params.id}/visual-builder${
            source === 'EXPERIMENT' ? '/experiment' : ''
          }`
        )
      }

      await pause(300)
      scrollToNode(id)
      await pause(200)
    }

    onClickOutside()
  }

  const renderPlaybookErrors = () => {
    const errors = []

    for (const id in editorErrors) {
      const sourceWithError = editorErrors[id] || {}
      const { source, nodeLabel = '', message = '' } = sourceWithError

      errors.push(
        <Div key={id} className="playbook-errors-notifier--accordion">
          <Span>
            {`${message} `}
            <b>{nodeLabel}</b>
          </Span>

          <Div
            className="playbook-errors-notifier--message-block__view"
            onClick={() => {
              handleScrollTo(source, id)
              showErrorMargin(id, message === 'Empty path in')
            }}
          >
            View
          </Div>
        </Div>
      )
    }

    return errors
  }

  return (
    <Div className="playbook-errors-notifier--dropdown">
      <Div className="playbook-errors-notifier--dropdown__header">
        {notifierHeader}
      </Div>
      {renderPlaybookErrors()}
    </Div>
  )
}

export default compose(onClickOutside, withRouter)(Dropdown)
